import { COMPONENT_TYPE } from 'common/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const floatAbove = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.FLOAT_ABOVE> =>
	createModel({
		type: COMPONENT_TYPE.FLOAT_ABOVE,
		nodeType: 'fla',
		editorProps: {
			selectable: false,
			draggable: false,
			expandable: true,
			expanded: true,
		},
		componentProps: {
			styles: {},
			other: {},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.FLOAT_ABOVE>;
